module.exports = __webpack_public_path__ + "static/media/logo.274e604e.png";